













import { Component, Vue, Emit } from 'vue-property-decorator'
import { RouteConfig, RouteRecord } from 'vue-router'
import deepClone from 'lodash/cloneDeep'
import TenantSidebarMenu from '@/components/TenantSidebarMenu/index.vue'
import TenantSidebarTree from '@/components/TenantSidebarTree/index.vue'
import { buildTenantRouteSidebarNodes } from '@/utils/tenant-sidebar'

const { body } = document
const WIDTH = 992 // refer to Bootstrap's responsive design

@Component({
    components: {
        TenantSidebarMenu,
        TenantSidebarTree
    }
})
export default class SidebarComponent extends Vue {
    isCollapse = false

    get routes(): RouteConfig[] {
        const originRoute = deepClone((this.$router as any).options.routes)
        const [layoutRoute] = originRoute
        // this.remove(layoutRoute.children)
        // console.log('routes ==>',layoutRoute,layoutRoute.children)
        return layoutRoute.children
    }

    get sidebarNodes() {
        const privileges = Array.isArray(this.$store.getters.privileges)
            ? this.$store.getters.privileges
            : []
        return buildTenantRouteSidebarNodes(this.routes, {
            flattenSingleChild: false,
            isVisible: (route: RouteConfig) => Boolean(
                route.meta && !route.hidden && !route.meta.hidden
            ),
            hasAccess: (route: RouteConfig) => Boolean(
                route.meta && privileges.includes(route.meta.code)
            ),
            getChildren: (route: RouteConfig) => (
                route.meta && route.meta.hideChildren ? [] : route.children
            ),
            getNodePath: (route: RouteConfig, currentPath: string) => (
                route.meta && route.meta.hideChildren && route.redirect
                    ? String(route.redirect)
                    : currentPath
            ),
            getTitle: (meta: any) => meta.title ? this.$t(meta.title) : ''
        })
    }

    // get activeRoute(): string {
    //     return this.$route.path.indexOf('/') === 0 ? this.$route.path.substring(1) : this.$route.path
    // }
    get defaultActiveIndex() {
        let index = ''
        this.$route.matched.forEach((match: RouteRecord) => {
            if (match.meta.hideChildren) {
                if (match.redirect) {
                    index = match.redirect as string
                } else {
                    index = match.path
                }
            }
        })
        if (!index) {
            index = this.$route.path
        }

        return index
    }

    get foldIconClass(): string {
        return this.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
    }

    @Emit('collapsed')
    toggleSwitch(): boolean {
        this.isCollapse = !this.isCollapse
        return this.isCollapse
    }

    created(): void {}

    beforeMount() {
        window.addEventListener('resize', this.resizeHandler)
    }

    mounted() {
        const isMobile = this.isMobile()

        if (isMobile) {
            this.isCollapse = true
            this.$emit('collapsed', true)
        }
    }

    isMobile() {
        const rect = body.getBoundingClientRect()
        return rect.width - 1 < WIDTH
    }

    resizeHandler() {
        if (!document.hidden) {
            const isMobile = this.isMobile()

            if (isMobile) {
                this.isCollapse = true
                this.$emit('collapsed', true)
            }
        }
    }

    navigateSidebarNode(node: any): void {
        if (!node || !node.target) {
            return
        }
        if (node.external) {
            window.location.href = node.target
            return
        }
        if (this.$route.path !== node.target) {
            this.$router.push(node.target)
        }
    }

    remove(option: RouteConfig[]) {
        option.map((op: RouteConfig) => {
            if (op.meta && op.meta.suppressChildren) {
                op.children = []
            }
            if (op.children) {
                this.remove(op.children)
            }

            return null
        })
    }
}
